import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ampli } from 'lib-shared-tracking';
import * as React from 'react';

import styles from './titleInput.module.scss';
import { FlowType } from './types';

type PropsT = {
  className?: string;
  initialValue: string;
  onChange: (value: string) => void;
  flowType: FlowType;
};

type StateT = {
  value: string;
  isEditing: boolean;
};

export class TitleInput extends React.PureComponent<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);

    const { initialValue } = props;

    this.state = {
      value: initialValue,
      isEditing: false,
    };
  }

  handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target instanceof HTMLInputElement) {
      this.setState({
        value: event.target.value,
      });
    }
  };

  handleOnChange = () => {
    const { onChange, initialValue } = this.props;
    const { value } = this.state;
    if (value !== initialValue) onChange(value);
    this.setState({
      isEditing: false,
    });
  };

  handleFocus = () => {
    const { flowType } = this.props;
    ampli.flowTitleEditClicked({
      flowType,
    });
    this.setState({
      isEditing: true,
    });
  };

  handleBlur = () => {
    this.setState(
      {
        isEditing: false,
      },
      this.handleOnChange,
    );
  };

  handleKeyUp = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      this.handleOnChange();
      this.setState({
        isEditing: false,
      });
    } else if (event.key === 'Escape') {
      const { initialValue } = this.props;
      this.setState({
        isEditing: false,
        value: initialValue,
      });
    }
  };

  render() {
    const { className, initialValue, onChange, flowType, ...otherProps } =
      this.props;
    const { value, isEditing } = this.state;

    const rootClass = classnames(
      {
        [styles.root]: true,
        [styles.rootEditing]: isEditing,
        [styles.rootUntitled]: value === '',
      },
      className,
    );

    return (
      <div {...otherProps} className={rootClass}>
        <label className={styles.preview}>
          <span className={styles.text}>{value || 'Name your flow'}</span>
          <div className={styles.inputContainer}>
            <input
              spellCheck="false"
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              className={styles.input}
              onChange={this.handleInput}
              onKeyUp={this.handleKeyUp}
              value={value}
              placeholder="Name your flow"
            />
          </div>
          <Icon
            className={classnames('icon-vertical-fix', styles.icon)}
            name="pen"
          />
        </label>
      </div>
    );
  }
}
